import { Flex, Menu, MenuButton, Button, MenuItem, MenuList } from '@vimeo/bokeh';
import { GlobeAlt, ChevronDownSmall, CheckSmall } from '@vimeo/bokeh-icons';

interface Language {
  value: string;
  label: string;
}

interface MultilingualSelectorProps {
  languages: Language[];
  selectedLanguage: string;
  onSelectLanguage: (language: string) => void;
  isEmbeded?: boolean;
}

export const MultilingualSelector = ({
  languages,
  selectedLanguage,
  onSelectLanguage,
  isEmbeded,
}: MultilingualSelectorProps) => {
  // languageLabelsByCode will be: { en: 'English', fr: 'Français', es: 'Español' }
  const languageLabelsByCode = languages.reduce((acc: { [key: string]: string }, lang) => {
    acc[lang.value] = lang.label;
    return acc;
  }, {});

  const hasMultipleLanguages = languages.length > 1;
  return (
    <>
      {hasMultipleLanguages && (
        <Flex width="100%" justifyContent="flex-end">
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<GlobeAlt />}
              rightIcon={<ChevronDownSmall />}
              variant="tertiary"
              size="xs"
            >
              {languageLabelsByCode[selectedLanguage]}
            </MenuButton>
            <MenuList position="relative" right="0px" marginTop="-3px" width="217px">
              {languages.map((item) => {
                const value = item.value as string;
                const language = item.label as string;
                const selectedOptionIcon = value === selectedLanguage ? <CheckSmall /> : '';
                const text = languageLabelsByCode[value ?? ''] || language;
                return (
                  <MenuItem
                    sx={isEmbeded ? { color: 'white' } : undefined}
                    key={language}
                    onClick={() => onSelectLanguage(value || 'en')}
                  >
                    <Flex width="100%" justifyContent="space-between" alignItems="center">
                      {text}
                      {selectedOptionIcon}
                    </Flex>
                  </MenuItem>
                );
              })}
            </MenuList>
          </Menu>
        </Flex>
      )}
    </>
  );
};
